import axios from "axios";
import router from "../router";
import store from "../store/index";
const service = axios.create({
  withCredentials: false,
  timeout: 0, // no timeout
  headers: {
    "content-type": "application/json",
  },
});

service.interceptors.request.use(
  (config) => {
    const authToken = sessionStorage.getItem("__ac_mn_tk");
    config.headers["Authorization"] = "Bearer " + authToken;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
service.interceptors.response.use(
  async function (res) {
    if (res.data.status_code === 200 || res.data.access_token) {
      return res;
    }
    if (res.data.status_code === 401) {
      if (router.currentRoute.meta && router.currentRoute.meta.requiresAuth) {
        const originalConfig = res.config;
        const token = sessionStorage.getItem("__re_acc_tk");
        if (token && res.data) {
          if (!originalConfig._retry) {
            originalConfig._retry = true;
            try {
              const response = await axios.post(
                `${process.env.VUE_APP_BASEURL_NEW}/api/v1/admin/refresh-token?token=${token}`,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                },
              );
              if (response.data.status_code == 200) {
                sessionStorage.setItem(
                  "__ac_mn_tk",
                  response.data.data[0].access_token,
                );
                console.log(
                  "responseRefresh",
                  response.data.data[0].access_token,
                );
                res.config.headers[
                  "Authorization"
                ] = `Bearer ${response.data.data[0].access_token}`;
                return new Promise((resolve, reject) => {
                  axios
                    .request(originalConfig)
                    .then((response) => {
                      resolve(response);
                    })
                    .catch((err) => {
                      reject(err);
                    });
                });
              } else if (response.data.status_code === 408) {
                store.commit("setSessionOut", true);
              }
            } catch (err) {
              console.error(err);
              throw err;
            }
          }
        }
        return Promise.reject(res);
      } else {
        return res;
      }
    } else if (res && res.data && res.data.status_code === 408) {
      store.commit("setSessionOut", true);
    } else {
      return res;
    }
  },
  function (error) {
    // forbidden
    if (error.response.status == 408) {
      //route to forbidden page
      store.commit("setSessionOut", true);
    }
    return Promise.reject(error.response.data);
  },
);

export default service;
